if (!customElements.get('adev-recently-viewed')) {
    customElements.define('adev-recently-viewed', class adevRecentlyViewed extends HTMLElement {
        constructor() {
            super();
        }

        getCurrentProductHandle() {
            // Extract the current product handle from /products/<handle> in the URL.
            // Returns null if not on a product page.
            const match = window.location.pathname.match(/\/products\/([^\/?#]+)/);
            return match ? match[1] : null;
        }

        // Mon Chou: init/teardown slick on desktop so the PDP "Set for nyligt"
        // section behaves as a carousel with prev/next arrows, matching the
        // other carousels on the site. Mobile keeps its native horizontal
        // scroll (defined in adev-pdp-carousels.css).
        initCarousel() {
            const listEl = this.querySelector('[data-adev-recently-viewed="items"]');
            if (!listEl) return;
            if (!window.jQuery || !window.jQuery.fn || !window.jQuery.fn.slick) return;
            const $ = window.jQuery;
            const isDesktop = window.innerWidth >= 992;
            const isInited = listEl.classList.contains('slick-initialized');
            const childCount = listEl.children.length;

            if (isDesktop && !isInited && childCount > 0) {
                const prevSvg = '<button type="button" class="slick-prev-arrow slick-arrow" aria-label="Previous"><svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" viewBox="0 0 24 24"><g stroke-width="1.5" fill="none"><path d="M15 6l-6 6l6 6" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/></g></svg></button>';
                const nextSvg = '<button type="button" class="slick-next-arrow slick-arrow" aria-label="Next"><svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" viewBox="0 0 24 24"><g stroke-width="1.5" fill="none"><path d="M9 6l6 6l-6 6" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/></g></svg></button>';
                $(listEl).slick({
                    arrows: true,
                    dots: false,
                    infinite: false,
                    speed: 400,
                    slidesToShow: 4,
                    slidesToScroll: 1,
                    adaptiveHeight: true,
                    prevArrow: prevSvg,
                    nextArrow: nextSvg
                });
            } else if ((!isDesktop || childCount === 0) && isInited) {
                $(listEl).slick('unslick');
            }
        }

        loadProducts() {
            let recentlyViewedProducts = Cookies.get('adev_recently_viewed_products') ? JSON.parse(Cookies.get('adev_recently_viewed_products')) : [];

            // Exclude the product currently being viewed.
            const currentHandle = this.getCurrentProductHandle();
            if (currentHandle) {
                recentlyViewedProducts = recentlyViewedProducts.filter(function(handle) {
                    return handle !== currentHandle;
                });
            }

            // Cap at 10 products.
            recentlyViewedProducts = recentlyViewedProducts.slice(0, 10);

            const listEl = this.querySelector('[data-adev-recently-viewed="items"]');

            // If a previous slick instance exists on the list, tear it down before
            // overwriting innerHTML — otherwise slick keeps stale DOM references.
            if (window.jQuery && window.jQuery.fn && window.jQuery.fn.slick && listEl && listEl.classList.contains('slick-initialized')) {
                window.jQuery(listEl).slick('unslick');
            }

            listEl.innerHTML = '';

            // If there are no recently viewed products at all, skip the network requests entirely.
            if (recentlyViewedProducts.length === 0) {
                return;
            }
            
            const requests = [];

            recentlyViewedProducts.forEach(function(handle) {
                let rootUrl = theme.routes.rootUrl;
                rootUrl = rootUrl.endsWith('/') ? rootUrl : rootUrl + '/';

                const url = rootUrl + 'products/' + handle + '?section_id=adev-recently-viewed-items';

                requests.push(fetch(url).then(response => response.text()));
            });

            const self = this;
            Promise.all(requests).then(function(responses) {
                // Mon Chou (Claude, 2026-06-10): de-duplicate by canonical product URL.
                // The recorder stores the LOCALIZED handle of the page being viewed, so a
                // product browsed in two languages (e.g. Danish and /en/) is recorded twice
                // under two different handles. Shopify resolves both fetches to the same
                // product, so the rendered card link is identical — use it as the dedupe key.
                // The current page's product path is seeded into the set so the product being
                // viewed never shows up in its own "recently viewed" list via a cross-language
                // handle. Everything else (order, markup, carousel) is unchanged.
                const seenProducts = new Set();
                const currentPath = window.location.pathname.match(/\/products\/[^\/?#]+/);
                if (currentPath) { seenProducts.add(currentPath[0]); }

                responses.forEach(function(response) {
                    
                    const domParser = new DOMParser();
                    const doc = domParser.parseFromString(response, 'text/html');
                    
                    const section = doc.querySelector('#shopify-section-adev-recently-viewed-items');
                    if (section) {
                        const link = section.querySelector('a[href*="/products/"]');
                        const keyMatch = link ? String(link.getAttribute('href')).match(/\/products\/[^\/?#]+/) : null;
                        const key = keyMatch ? keyMatch[0] : null;
                        if (key) {
                            if (seenProducts.has(key)) { return; }
                            seenProducts.add(key);
                        }
                        const productHtml = section.innerHTML;
                        listEl.innerHTML += productHtml;
                    }
                    
                });

                if (listEl.children.length > 0) {
                    self.classList.add('has-products');
                    // Mon Chou: initialize the slick carousel on desktop now that
                    // products are in the DOM.
                    self.initCarousel();
                }
            });
        }

        connectedCallback() {
            // Load products immediately on connect. The previous IntersectionObserver-based
            // lazy load is incompatible with hiding the section via CSS — a hidden element
            // never intersects the viewport, so the loader would never fire.
            this.loadProducts();

            // Mon Chou: re-evaluate slick init on viewport resize so the carousel
            // mounts/unmounts when crossing the desktop breakpoint.
            const self = this;
            this._onResize = function() {
                if (self._resizeTimer) clearTimeout(self._resizeTimer);
                self._resizeTimer = setTimeout(function() { self.initCarousel(); }, 150);
            };
            window.addEventListener('resize', this._onResize);
        }

        disconnectedCallback() {
            if (this._onResize) {
                window.removeEventListener('resize', this._onResize);
                this._onResize = null;
            }
        }

    });
}
